/**
 * Allys Properties List Skeleton
 *
 * Matches AllysListingsContent: gradient hero with stats,
 * sticky filter bar, and 3-column listing grid.
 * Includes navigation skeleton so the nav bar is always visible.
 */

import { AllysNavSkeleton } from './AllysNavSkeleton';

export function AllysPropertiesSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AllysNavSkeleton />

      {/* Hero header */}
      <section className="bg-linear-to-b from-[#243462]/5 to-gray-50 pt-24 pb-12 px-4 md:px-8 skeleton-stagger-1">
        <div className="mx-auto max-w-7xl">
          <div className="h-1 w-16 rounded-full bg-[#BBA339]/40 mb-6 skeleton-shimmer" />
          <div className="h-10 w-72 rounded-lg bg-gray-200 mb-3 skeleton-shimmer" />
          <div className="h-5 w-96 max-w-full rounded bg-gray-100 mb-8 skeleton-shimmer" />
          <div className="flex flex-wrap gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="space-y-1">
                <div className="h-7 w-12 rounded bg-gray-200 skeleton-shimmer" />
                <div className="h-3 w-20 rounded bg-gray-100 skeleton-shimmer" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky filter bar */}
      <section className="sticky top-16 z-30 bg-white border-b border-gray-200 shadow-sm skeleton-stagger-2">
        <div className="mx-auto max-w-7xl px-4 md:px-8 py-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-48 rounded-xl bg-gray-100 skeleton-shimmer" />
            <div className="h-10 w-32 rounded-xl bg-gray-100 skeleton-shimmer" />
            <div className="h-10 w-32 rounded-xl bg-gray-100 skeleton-shimmer" />
            <div className="h-10 w-28 rounded-xl bg-gray-100 ml-auto hidden md:block skeleton-shimmer" />
          </div>
        </div>
      </section>

      {/* Results + grid */}
      <section className="py-10 px-4 md:px-8 skeleton-stagger-3">
        <div className="mx-auto max-w-7xl">
          <div className="h-4 w-32 rounded bg-gray-200 mb-8 skeleton-shimmer" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100">
                <div className="aspect-4/3 bg-linear-to-br from-gray-200 to-gray-100 skeleton-shimmer" />
                <div className="p-5 space-y-3">
                  <div className="h-3 bg-gray-200 rounded-full w-1/2 skeleton-shimmer" />
                  <div className="h-5 bg-gray-200 rounded-lg w-3/4 skeleton-shimmer" />
                  <div className="h-7 bg-[#243462]/10 rounded-lg w-1/3 skeleton-shimmer" />
                  <div className="flex gap-4 py-2 px-3 bg-gray-50 rounded-xl">
                    <div className="h-4 bg-gray-200 rounded w-14 skeleton-shimmer" />
                    <div className="h-4 bg-gray-200 rounded w-14 skeleton-shimmer" />
                    <div className="h-4 bg-gray-200 rounded w-20 skeleton-shimmer" />
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <div className="h-4 bg-gray-200 rounded w-24 skeleton-shimmer" />
                    <div className="h-8 w-8 rounded-full bg-gray-100 skeleton-shimmer" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
